import { DropdownItem, MenuItem } from "@/types/navbar";

export const getMenuItems = (
  services: DropdownItem[],
  enableResources: boolean = true
): MenuItem[] => {
  const menuItems = [
    { label: "Home", href: "/" },
    {
      label: "Services",
      href: "/services/all",
      isDropdown: true,
      dropdownItems: services,
    },
    { label: "About", href: "/about" },
    { label: "Contact", href: "/contact" },
  ];

  if (enableResources) {
    menuItems.splice(2, 0, { label: "Resources", href: "/resources/all" });
  }

  return menuItems;
};
